import { connect } from 'react-redux';
import { useTheme } from 'styled-components';

/* Styled Components */
import {
  SectionSubtitle,
  PaddedContainer,
  SuccessText,
  SectionBorder,
  StepIconWrapper,
  StepIcon,
  Steps,
  StepWrapper,
  CheckWrapper,
  AppLinkWrapper,
  AppStoreLink,
} from 'styles/signup/MultiScreenSignupPage';

/* Utils */
import { i18n } from 'utils/i18n';

/* Icons */
import CheckIcon, { CHECK_VARIANT_KEYS } from 'icons/CheckIcon';
import AppleAppStoreIcon from 'icons/AppleAppStore';
import GooglePlayStoreIcon from 'icons/GooglePlayStore';

/* Constants */
import { GOOGLE_PLAY_LINK, APP_STORE_LINK } from 'constants/AppConstants';

/* Types */
import type { AppState } from 'app/store';

const STEPS = () => [
  i18n('Download the Wish Local app'),
  i18n('Log in with your email and password'),
  i18n('Start growing your business!'),
];

const mapStateToProps = (_: AppState) => ({});

type PropsType = ReturnType<typeof mapStateToProps>;

const SuccessPage = (_: PropsType) => {
  const theme = useTheme();

  // helper function that returns a full step
  const getStep = (stepNumber: number) => (
    <StepWrapper>
      <StepIconWrapper>
        <StepIcon>{stepNumber}</StepIcon>
      </StepIconWrapper>
      <SectionSubtitle>{STEPS()[stepNumber - 1]}</SectionSubtitle>
    </StepWrapper>
  );

  const getAppStoreLinks = () => (
    <AppLinkWrapper>
      <AppStoreLink>
        <a href={GOOGLE_PLAY_LINK} rel="noopener noreferrer">
          <GooglePlayStoreIcon />
        </a>
      </AppStoreLink>
      <AppStoreLink>
        <a href={APP_STORE_LINK} rel="noopener noreferrer">
          <AppleAppStoreIcon />
        </a>
      </AppStoreLink>
    </AppLinkWrapper>
  );

  return (
    <PaddedContainer>
      <CheckWrapper>
        <CheckIcon
          variant={CHECK_VARIANT_KEYS.CIRCLED}
          overrideStyle={{
            width: '32px',
            height: '32px',
            stroke: theme.white,
            fill: theme.PickupGreen,
          }}
        />
      </CheckWrapper>
      <SuccessText>{i18n('Account created!')}</SuccessText>
      <SectionBorder />
      <SectionSubtitle topMarginSmall style={{ fontWeight: 'bold' }}>
        {i18n('Next steps')}
      </SectionSubtitle>
      <Steps>
        {getStep(1)}
        {getAppStoreLinks()}
        {getStep(2)}
        {getStep(3)}
      </Steps>
    </PaddedContainer>
  );
};

export default connect(mapStateToProps)(SuccessPage);
